import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Catch-all 404 inside Brand OS.
 *
 * - Plain wording for Roger (no "Slices 2–4" build jargon).
 * - Logs the bad path to the console *and* fires a best-effort
 *   `/api/_frontend/log-404` POST so we can mine the server logs for
 *   other dead links that still ship from the UI.
 */
export default function NotFound() {
  const location = useLocation();
  const badPath = `${location.pathname}${location.search || ""}`;

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn(`[brand-os] 404: unrouted path ${badPath}`);
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL || ""}/api/_frontend/log-404`;
      fetch(url, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          path: badPath,
          referrer: document.referrer || null,
          ua: navigator.userAgent || null,
        }),
      }).catch(() => { /* ignore */ });
    } catch { /* ignore */ }
  }, [badPath]);

  return (
    <div className="bo-root">
      <div className="bo-login-shell">
        <div className="bo-login-card" style={{ textAlign: "center" }}>
          <div className="bo-login-eyebrow">Brand OS</div>
          <h1 className="bo-login-title">This page isn&rsquo;t available.</h1>
          <p className="bo-login-lede" data-testid="notfound-lede">
            The link you followed doesn&rsquo;t match any page in Brand OS.
            Head back to Command Center.
          </p>
          <p
            className="bo-mono"
            data-testid="notfound-bad-path"
            style={{
              marginTop: 8, fontSize: 12,
              color: "var(--bo-muted, #888)",
              wordBreak: "break-all",
            }}
          >
            {badPath}
          </p>
          <Link
            className="bo-btn bo-btn-ghost"
            to="/brand-os"
            data-testid="notfound-back"
            style={{ marginTop: 16 }}
          >
            Back to Command Center
          </Link>
        </div>
      </div>
    </div>
  );
}
